/**
 * Ayudas para pintar los catálogos de las hojas de apoyo del FOS-005. Las
 * usan las Hojas de apoyo y sirven igual para cualquier pantalla que muestre
 * esos mismos catálogos.
 */

/** Una clase CSS y las claves que, contenidas en el texto, la eligen. */
export type ReglaClase = readonly [clase: string, claves: readonly string[]];

/**
 * La clase de un texto por coincidencia parcial: gana la primera regla que
 * tenga alguna clave contenida en el texto (en mayúsculas); si ninguna, la de
 * respaldo. Así un renombre conserva su color, y el orden de las reglas
 * decide los textos que contienen dos claves.
 */
export function clasePorTexto(texto: string | undefined, reglas: readonly ReglaClase[], respaldo: string): string {
  const t = (texto || "").toUpperCase();
  const regla = reglas.find(([, claves]) => claves.some((clave) => t.includes(clave)));
  return regla ? regla[0] : respaldo;
}

/**
 * Un color vivo por categoría del catálogo de amenazas. ERROR/FALLO va antes
 * que INTENCIONADO porque "ERRORES Y FALLOS NO INTENCIONADOS" contiene ambos.
 * Una categoría nueva sale en el azul del sistema (cat-otra).
 */
export const CLASES_CATEGORIA: readonly ReglaClase[] = [
  ["cat-nat", ["NATURAL"]],
  ["cat-ind", ["INDUSTRIAL"]],
  ["cat-err", ["ERROR", "FALLO"]],
  ["cat-ata", ["ATAQUE", "INTENCIONADO"]],
];

/**
 * El color que el Excel le da a cada estrategia: Evitar oscuro, Transferir
 * naranja, Mitigar verde y Aceptar rojo. MITIG va antes que EVITAR porque
 * "Mitigar/Eliminar" contiene ambos. Una estrategia nueva sale en el azul del
 * sistema (est-neutra).
 */
export const CLASES_ESTRATEGIA: readonly ReglaClase[] = [
  ["est-mitigar", ["MITIG"]],
  ["est-transferir", ["TRANSFER"]],
  ["est-aceptar", ["ACEPT"]],
  ["est-evitar", ["EVITAR", "ELIMINAR"]],
];

/** Los renglones de un catálogo con ese valor en el campo, en el orden en que vienen. */
export function renglonesCon<T, K extends keyof T>(lista: T[], campo: K, valor: T[K]): T[] {
  return lista.filter((r) => r[campo] === valor);
}
